<template>
  <div class="detail">
    <div class="detail-wrapper">
      <div class="detail-container">
        <div class="profile-container">
          <comp-profile
            :userInitial="userName"
            :profileImage="userProfileImage"
          />
        </div>

        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t('match.name') }}</td>
            <td style="padding: 0 15px">
              <div class="btn-like-input">
                {{ name }}
              </div>
            </td>
          </tr>
        </table>
        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t('match.nickname') }}</td>
            <td style="padding: 0 15px">
              <div class="btn-like-input">
                {{ nickName }}
              </div>
            </td>
          </tr>
        </table>
        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t('match.email') }}</td>
            <td style="padding: 0 15px">
              <div class="btn-like-input">
                {{ email }}
              </div>
            </td>
          </tr>
        </table>
        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t('match.birth') }}</td>
            <td style="padding: 0 15px">
              <div class="btn-like-input">
                {{ birthYear }}
              </div>
            </td>
          </tr>
        </table>
        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t('match.education') }}</td>
            <td style="padding: 0 15px">
              <div class="btn-like-input">
                {{ getEducation }}
              </div>
            </td>
          </tr>
        </table>
        <table class="form-table">
          <tr>
            <td class="text-cell">{{ $t('match.jobs') }}</td>
            <td style="padding: 0 15px">
              <div class="btn-like-input">
                {{ jobs }}
              </div>
            </td>
          </tr>
        </table>

        <div style="height: 30px;"></div>

      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common';
import FormInput from '@/components/FormInput';
import FormSelect from '@/components/FormSelect';
import CompProfile from '@/components/CompProfile';
import RESPONSE from '@/constants/response';

export default {
  name: 'index',
  mixins: [
    common,
  ],
  data() {
    return {
      userName: '',
      userProfileImage: '',
      name: '',
      nickName: this.$i18n.t('match.nickname'),
      email: this.$i18n.t('match.email'),
      birthYear: this.$i18n.t('match.birth'),
      education: '',
      jobs: this.$i18n.t('match.jobs'),

      yearData: this.years(),
    };
  },
  computed: {
    getEducation() {
      if (this.education === 0) {
        return this.$i18n.t('common.education.middle');
      } else if (this.education === 1) {
        return this.$i18n.t('common.education.high');
      } else if (this.education === 2) {
        return this.$i18n.t('common.education.college');
      } else if (this.education === 3) {
        return this.$i18n.t('common.education.university');
      } else if (this.education === 4) {
        return this.$i18n.t('common.education.graduate');
      }
      return this.$i18n.t('common.education.university');
    },
  },
  components: {
    CompProfile,
    FormSelect,
    FormInput,
  },
  methods: {
    getProfile() {
      const userSeqId = this.$route.params.id;
      this.$store.dispatch('getProfile', { userSeqId }).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getProfile();
            } else {
              this.invalidateLogin();
            }
          });
        } else {
          const profile = data.data;
          this.name = profile.name;
          this.userProfileImage = `${process.env.API_BASE_URL}/files/${userSeqId}/${profile.photo.fileName}`;
          this.userName = profile.name.split('')[0];
          this.nickName = profile.nickname;
          if (profile.etc.email) {
            this.email = profile.etc.email;
          }
          if (profile.birth) {
            this.birthYear = profile.birth;
          }
          if (profile.etc.education) {
            this.education = profile.etc.education;
          }
          if (profile.etc.jobs) {
            const occupation = JSON.parse(profile.etc.jobs);
            const storeJobList = this.$store.getters.getJobs;
            const tmpList = [];
            for (let i = 0; i < storeJobList.length; i += 1) {
              for (let j = 0; j < occupation.length; j += 1) {
                if (storeJobList[i].jobCode === occupation[j]) {
                  tmpList.push(storeJobList[i].jobName);
                }
              }
            }
            this.jobs = tmpList.join(', ');
          }
        }
      });
    },
  },
  created() {
    this.getProfile();
  },
};
</script>

<style lang="scss" src="../../scss/acc-detail.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/profile/index.vue